import styled from '@emotion/styled';

const Second:React.FC<any> = () => {
  return (
    <Container>
      <BodyContainer className='first'>
        <BodyImgContainer className="first">
        <Img src="/images/newLanding/product/1245.png"/>
        </BodyImgContainer>
        <Text2>인테리어에 &nbsp;<span>감각을 더하는 앨범</span></Text2>
        <SmallText>
            의미있는 아이템을
            <br/>보이지 않게 숨겨둘 수는 없으니까요
        </SmallText>
      </BodyContainer>
      <BodyContainer className='second'>
        <BodyImgContainer className="first">
          <Img src="/images/newLanding/product/368722019.png"/>
        </BodyImgContainer>
        <Text2>백사장의 모래를 닮은 &nbsp;<span>고급스런 촉감</span></Text2>
        <SmallText>
          최고급 종이의 부드러운 결은
          <br/>만질 때 그 감성을 더합니다
        </SmallText>
      </BodyContainer>
      <BodyContainer className='first'>
        <BodyImgContainer className="first">
          <Img src="/images/newLanding/product/1508.png"/>
        </BodyImgContainer>
        <Text2>안전하고 깔끔하게 보관, &nbsp;<span>단단한 속지</span></Text2>
        <SmallText>
          포티페타만의 바인더 속지는
          <br/>소중한 사진을 단단하게 고정해주어요
        </SmallText>
      </BodyContainer>
      <BodyContainer className='second'>
        <BodyImgContainer className="first">
          <Img src="/images/newLanding/product/357673.png"/>
        </BodyImgContainer>
        <Text2>사진 고정도 &nbsp;<span>안심하세요</span></Text2>
        <SmallText>
          모서리만 단단히 고정해        
          <br/>생생한 색감을 즐길 수 있는 포티페타만의 방법
        </SmallText>
      </BodyContainer>
      <BodyContainer className='first'>
        <BodyImgContainer className="first">
          <Img src="/images/newLanding/product/368722021.png"/>
        </BodyImgContainer>
        <Text2>사진에 가려두는, &nbsp;<span>깜짝 메모 선물</span></Text2>
        <SmallText>
          줄노트에 기록수 사진으로 덮을 수 있어요
          <br/>자녀의 미래에 보내는 편지를 남겨보세요
        </SmallText>
      </BodyContainer>
    </Container>
  )
}

export default Second;

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;


const Img = styled.img`
  width: 100%;
`;

const BodyContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 40px 0;

  &.first{
    background-color: #f0Ede7;
  }

  &.second {
    background-color: #ede3cd;
  }
`

const BodyImgContainer = styled.div`
  &.first {
    width: 90%;
    margin: 0 auto;
    
  }
    
`
const Text1 = styled.div`
  font-size: 18px;
  display: flex;
  margin: 40px auto 80px;
  font-weight: 600;
  text-align: center;
`;

const SmallText = styled.div`
  font-size: 14px;
  margin: 30px auto 100px;
  text-align: center;
`;

const Text2 = styled.div`
  font-size: 20px;
  display: flex;
  margin: 40px auto 0px;

  span {
    font-weight: 600;
  }
`;